import {omit} from 'lodash';
import {updateEducator, getEducator} from 'shared/actions/educator';
import {changesSaved, errorMessage} from 'shared/actions/notifications';
import {verifyPhoneNumber} from 'shared/actions/verify-mobile';
import {stopLoading} from 'shared/actions/loading';
import {RECEIVE_EDUCATOR} from 'educator/action-types/educator';
import {receiveNotificationSettings} from 'shared/account-settings/actions/notification-settings';

export const EDUCATOR_FIELDS = [
  'title',
  'firstName',
  'lastName',
  'email',
  'mobile',
  'institution',
  'linkedinConnected',
  'officialIdPath',
  'websiteForEmployment',
].join(',');

export const getEducatorInfo = () => (dispatch) =>
  getEducator('me', `${EDUCATOR_FIELDS},notificationSettings`)
    .then((educator) => {
      dispatch({
        type: RECEIVE_EDUCATOR,
        payload: omit(educator, ['notificationSettings']),
      });
      dispatch(stopLoading());
      dispatch(receiveNotificationSettings(educator.notificationSettings));
    })
    .catch(() => {
      dispatch(errorMessage());
    });

export const updateEducatorInfo =
  (educator, shouldValidateMobile = true) =>
  (dispatch) => {
    if (educator.mobilePartOne && educator.mobilePartTwo && educator.mobilePartThree) {
      educator.mobile = `${educator.mobilePartOne}${educator.mobilePartTwo}${educator.mobilePartThree}`;
    }

    if (
      educator.newEmail &&
      educator.newEmailRepeat &&
      educator.newEmail === educator.newEmailRepeat
    ) {
      educator.email = educator.newEmail;
    }

    return new Promise((resolve, reject) =>
      updateEducator(educator, EDUCATOR_FIELDS)
        .then((updatedEducator) => {
          dispatch({
            type: RECEIVE_EDUCATOR,
            payload: updatedEducator,
          });
          // for verifying mobile
          if (shouldValidateMobile && updatedEducator.mobile) {
            dispatch(verifyPhoneNumber(updatedEducator.mobile, 'sms'));
          } else {
            dispatch(changesSaved());
          }
          resolve();
        })
        .catch((errs) => {
          const errors = {};

          errs.forEach((err) => {
            switch (err.field) {
              case 'mobile':
                errors.mobilePartOne = `Mobile ${err.message}`;
                break;
              case 'email':
                errors.newEmail = err.message;
                break;
              default:
                errors[err.field] = err.message;
            }
          });

          reject(errors);
        })
    );
  };
